<template>
    <div>
        <header
            ref="ReaderHeader"
            dusk="ReaderHeader"
            role="banner"
            :inert="uiHidden"
            class="ReaderHeader fixed left-0 right-0 top-0 z-20 flex h-[var(--header-toolbar-height)] w-full select-none items-center justify-between bg-theme-bg px-3 py-3 opacity-100 transition-transform duration-200 ease-out md:px-4"
            :class="{
                'uiHidden overflow-hidden !border-0 !opacity-0': uiHidden,
            }"
        >
            <div class="flex w-1/3 items-center">
                <AudiobookHeaderActionsLeft v-if="isAudiobook" />
                <PdfEpubHeaderActionsLeft v-else />
            </div>

            <div v-if="showHeaderTitle" class="flex flex-grow items-center justify-center overflow-hidden">
                <h1
                    :class="[
                        'truncate',
                        'text-sm',
                        'leading-tight',
                        'm-0',
                        'text-center',
                        'text-theme-title',
                        'px-8',
                        'font-normal',
                    ]"
                >
                    {{ title }}
                </h1>
            </div>

            <div class="flex w-1/3 items-center justify-end">
                <AudiobookHeaderActionsRight v-if="isAudiobook" />
                <PdfEpubHeaderActionsRight v-else />
            </div>
        </header>
        <ReaderSettings />
    </div>
</template>

<script>
'use strict';

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import PdfEpubHeaderActionsRight from './Header/PdfEpubHeaderActionsRight.vue';
import ReaderSettings from './Settings/ReaderSettings.vue';
import PdfEpubHeaderActionsLeft from './Header/PdfEpubHeaderActionsLeft.vue';
import AudiobookHeaderActionsLeft from './Header/AudiobookHeaderActionsLeft.vue';
import AudiobookHeaderActionsRight from './Header/AudiobookHeaderActionsRight.vue';

export default {
    components: {
        AudiobookHeaderActionsRight,
        PdfEpubHeaderActionsRight,
        ReaderSettings,
        PdfEpubHeaderActionsLeft,
        AudiobookHeaderActionsLeft,
    },
    computed: {
        ...mapState(['ui', 'title', 'uiHidden', 'isOffline', 'localizations', 'lang', 'device']),
        ...mapGetters(['isPdf', 'isAudiobook', 'isEmbeddedMode', 'onlyDesktopVisible']),
        showHeaderTitle() {
            if (this.isAudiobook) {
                return true;
            }

            return this.onlyDesktopVisible || this.device?.orientation === 'landscape';
        },
    },
    mounted() {
        this.setHeaderbarOffsetHeight(this.$refs.ReaderHeader.offsetHeight);
    },
    methods: {
        ...mapMutations(['trackEvent', 'setHeaderbarOffsetHeight']),
        ...mapActions(['toggleThumbnails', 'toggleNotebook', 'toggleTableOfContents']),
    },
};
</script>

<style scoped>
.ReaderHeader.uiHidden {
    transform: translateY(calc(-1 * var(--header-toolbar-height)));
    transition:
        opacity 0ms ease-in 200ms,
        transform 200ms ease-in 0ms;
}
</style>
